import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar'; // Keep the sidebar
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const XAccount = () => {
  const [email, setEmail] = useState('');
  const [authId, setAuthId] = useState('');  // Added state for auth_id
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    // Fetch current user details API
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get('https://bvmwebsolutions.com/patreon-pass/backend/api/current-user-details', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          const userEmail = response.data.data.user.email;
          const userAuthId = response.data.data.user.auth_id;  // Extract auth_id from response
          setEmail(userEmail); // Set the email from the response
          setAuthId(userAuthId);  // Set the auth_id from the response
        } else {
          setErrorMessage('Error fetching user details');
        }
      } catch (error) {
        setErrorMessage('Error fetching user details');
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className="main_patreonpass_wrapper">
      <div className="patreonpass_container">
        <div className="left_sidebar">
          <MainSidebar /> {/* Keep the sidebar */}
        </div>
        <div className="patreonpass_main_content edit_profile_settings" id="content">
          <div className="left_main_content">
            <div className="feed_wrapper">
              <div className="page_title_with_dropdown notification_page">
                <div className="page_heading">
                  <button className="profile_back_btn" onClick={handleBackClick}>
                    <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  <h1>Linked accounts</h1> {/* Updated title */}
                </div>
              </div>
              <div className="menus_all_wrapper">
                <div className="edit_settings_menu_list">
                  <ul>
                    <li><a href="/editprofile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                    <li><a className='active_profile_menu' href="/accountsettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                    <li><a href="/privacy">Privacy and Safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                    <li><a href="/notificationsettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="right_main_content">
            <div className="linked_accounts">
              <div className="page_title_with_dropdown notification_page">
                <div className="page_heading">
                  <h1>Twitter Account</h1> {/* Updated title */}
                </div>
              </div>

              <div className="edit_profile_fields with_top_fixed_heading">
                <div className="fields_menu_bottom_box_edit_account edit_username_fields">
                  <div className="editable_fields_user edit_username_field">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <div className="b-field-like">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 509.64">
                              <rect width="512" height="509.64" rx="115.61" ry="115.61"/>
                              <path fill="#fff" fill-rule="nonzero" d="M323.74 148.35h36.12l-78.91 90.2 92.83 122.73h-72.69l-56.93-74.43-65.15 74.43h-36.14l84.4-96.47-89.05-116.46h74.53l51.46 68.04 59.53-68.04zm-12.68 191.31h20.02l-129.2-170.82H180.4l130.66 170.82z"/>
                            </svg>

                            {/* <span className="g-blue">{email}</span> */}
                            {/* Display the auth_id as a clickable link */}
                            {authId && (
                             
                                <a href={authId} target="_blank" rel="noopener noreferrer" className="auth_id_link">
                                {authId}
                                </a>
                             
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider_line" />
                  </div>
                </div>
              </div>

              {/* Display any messages if they exist */}
              {errorMessage && (
                <div className="text-danger">
                  {errorMessage}
                </div>
              )}
              {successMessage && (
                <div className="text-success">
                  {successMessage}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XAccount;  {/* Export the updated component */}
